import { render } from "./Step5.vue?vue&type=template&id=d98f63f0&scoped=true"
import script from "./Step5.vue?vue&type=script&lang=js"
export * from "./Step5.vue?vue&type=script&lang=js"

import "./tailwind.css?vue&type=style&index=0&id=d98f63f0&scoped=true&lang=css&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d98f63f0"]])

export default __exports__